import { useGetFellowCompassTokenQuery } from "store/services/adminAPI";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { profileSelector } from "store/reducers/ProfileReducer";
import { useSelector } from "react-redux";

const MAX_RETRIES = 5;
const RETRY_DELAY = 2000; // 2 seconds between retries

const CommunityResources = () => {
  const [skip, setSkip] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const { profileInfo } = useSelector(profileSelector);

  const { 
    data, 
    isFetching, 
    isError, 
    refetch 
  } = useGetFellowCompassTokenQuery(undefined, { skip });

  const token = profileInfo?.data?.profile?.compass_ai_token || data?.data?.compass_ai_token;

  useEffect(() => {
    // Only fetch if no token exists in profile
    setSkip(!!profileInfo?.data?.profile?.compass_ai_token);
  }, [profileInfo?.data?.profile?.compass_ai_token]);

  useEffect(() => {
    if (!token && !skip && !isFetching && retryCount < MAX_RETRIES) {
      const timer = setTimeout(() => {
        if (isError || !data) {
          setRetryCount(prev => prev + 1);
          refetch();
        }
      }, RETRY_DELAY);
      
      return () => clearTimeout(timer);
    }
  }, [token, skip, isFetching, isError, data, retryCount, refetch]);

  const iframeUrl = `https://org.compasai.com/6L5HWI/${token}`;

  return (
    <Col xl="12">
      {token ? (
        <iframe
          src={iframeUrl}
          width="100%"
          height="1000PX"
          title="Compass AI"
        />
      ) : retryCount >= MAX_RETRIES && !isFetching ? (
        <div className="p-5 text-center text-danger">
          Unable to load resources. Please try again later.
        </div>
      ) : (
        <div className="p-5 text-center">Loading resources...</div>
      )}
    </Col>
  );
};

export default CommunityResources;